import images from "../../../assets/images";
export const brandsMock = [
  {
    alt: "logo pão de açúcar",
    logo: images.logo.logo_pa
  },
  {
    alt: "logo pão de açúcar ponto com",
    logo: images.logo.logo_pa_com
  },
  {
    alt: "logo minuto pão de açúcar",
    logo: images.logo.logo_minuto_pa
  },
  {
    alt: "logo pão de açúcar posto",
    logo: images.logo.logo_pa_posto
  },
  {
    alt: "logo pão de açúcar drogaria",
    logo: images.logo.logo_pa_drogaria
  }
];

export const stepsMock = [
	{
		id: '1',
		title: 'Seja',
		sub: 'mais',
		desc: 'Mantenha seu cadastro sempre atualizado e não deixe de aproveitar os benefícios e vantagens que o programa oferece.'
	},
	{
		id: '2',
		title: 'Use',
		sub: 'mais',
		desc: 'Comprinha ou comprona? Não importa o valor, Cliente Mais sempre sai ganhando. Para isso se identifique com o seu CPF em todas as compras.'
	},
	{
		id: '3',
		title: 'Aproveite',
		sub: 'mais',
		desc: 'Baixe o app Pão de Açúcar Mais e aproveite ofertas exclusivas do Meu Desconto, ganhe Prêmios, encontre lojas próximas, agende horário no caixa e faça sua lista de compras.'
	}
];



// WEBPACK FOOTER //
// ./src/pages/home/mocks/index.js